/**
 * Farlo UI | Number Input
 *
 * @autho Farlo
 */

class FarloUiNumberInput {
	constructor(element) {
		this.element = element;
		this.initialiseNumberInput(this.element);
	}

	initialiseNumberInput(numberInput) {
		if (numberInput.parentNode.classList.contains('farlo-ui-numberinput')) {
			return; // bail out if already instantiated
		}

		// Set initial value to 0 if not set
		if (!numberInput.value || isNaN(numberInput.value)) {
			numberInput.value = 0;
		}

		// Set default min, max, and step values if not provided
		if (!numberInput.hasAttribute('min')) {
			numberInput.setAttribute('min', -999999);
		}
		if (!numberInput.hasAttribute('max')) {
			numberInput.setAttribute('max', 9999);
		}

		if (!numberInput.hasAttribute('value')) {
			numberInput.setAttribute('value', 0);
		}

		if (!numberInput.hasAttribute('step')) {
			numberInput.setAttribute('step', 1);
		} else if (numberInput.getAttribute('step').toLowerCase() === 'any') {
			numberInput.setAttribute('step', 1);
		}

		numberInput.classList.add('farlo-ui-numberinput__native');
		const numberField = this.createNumberFieldElement(numberInput);
		this.setupEvents(numberInput, numberField);
	}

	createNumberFieldElement(numberInput) {
		const numberField = document.createElement('div');
		numberField.classList.add('farlo-ui-numberinput');
		if (numberInput.disabled) {
			numberField.classList.add('farlo-ui-numberinput--disabled');
		}
		numberField.innerHTML = `
            <button type="button" class="farlo-ui-numberinput__decrement">-</button>
            <input class="farlo-ui-numberinput__native" type="number" value="${ numberInput.value }" min="${ numberInput.min }" max="${ numberInput.max }" step="${ numberInput.step }">
            <button type="button" class="farlo-ui-numberinput__increment">+</button>
        `;

		numberInput.parentNode.insertBefore(numberField, numberInput);
		numberField.replaceChild(numberInput, numberField.querySelector('.farlo-ui-numberinput__native'));

		return numberField;
	}

	setupEvents(numberInput, numberField) {
		const decrementButton = numberField.querySelector('.farlo-ui-numberinput__decrement');
		const incrementButton = numberField.querySelector('.farlo-ui-numberinput__increment');

		decrementButton.addEventListener('click', () => this.decrementValue(numberInput));
		incrementButton.addEventListener('click', () => this.incrementValue(numberInput));

		numberInput.addEventListener('input', () => this.validateValue(numberInput));
	}

	decrementValue(numberInput) {
		const step = numberInput.step ? parseFloat(numberInput.step) : 1;
		const min = numberInput.min ? parseFloat(numberInput.min) : -Infinity;
		const newValue = parseFloat(numberInput.value) - step;

		if (newValue >= min) {
			numberInput.value = newValue;
			numberInput.dispatchEvent(new Event('input')); // Commented out to check if value is updated
		}
	}

	incrementValue(numberInput) {
		const step = numberInput.step ? parseFloat(numberInput.step) : 1;
		const max = numberInput.max ? parseFloat(numberInput.max) : Infinity;
		const newValue = parseFloat(numberInput.value) + step;

		if (newValue <= max) {
			numberInput.value = newValue;
			numberInput.dispatchEvent(new Event('input')); // Commented out to check if value is updated
		}
	}

	validateValue(numberInput) {
		const min = numberInput.min ? parseFloat(numberInput.min) : -Infinity;
		const max = numberInput.max ? parseFloat(numberInput.max) : Infinity;
		const value = parseFloat(numberInput.value);

		if (value < min) {
			numberInput.value = min;
		} else if (value > max) {
			numberInput.value = max;
		}
	}
}

export default FarloUiNumberInput;
